import sagilityLogo from '../../../../assets/Logo/sagility-logo.png';

const LoginBanner = () => {
  return (
    <div
      className="
        hidden
        lg:flex

        min-h-[100dvh]
        w-1/2

        items-center
        justify-center

        overflow-hidden

        bg-gradient-to-br
        from-blue-700
        to-indigo-900

        px-[clamp(1rem,2.5vw,3rem)]
        py-[clamp(1.25rem,2.5vw,3rem)]
      "
    >
      <div
        className="
          w-full

          max-w-[clamp(360px,38vw,520px)]

          text-white

          animate-fadeIn
        "
      >
        {/* ======================================================
            SAGILITY LOGO
        ====================================================== */}

        <img
          src={sagilityLogo}
          alt="WorkVista"
          className="
            mx-auto

            mb-[clamp(0.9rem,1.8vw,2rem)]

            h-auto

            w-[clamp(170px,20vw,320px)]

            max-w-[75%]

            object-contain

            animate-float
          "
        />

        <div className="text-center">
          {/* ==================================================
              PLATFORM BADGE
          ================================================== */}

          <div
            className="
              inline-flex

              items-center

              px-[clamp(0.6rem,0.9vw,1rem)]
              py-[clamp(0.3rem,0.5vw,0.5rem)]

              mb-[clamp(0.9rem,1.5vw,1.5rem)]

              rounded-full

              bg-white/10

              backdrop-blur-sm

              border
              border-white/20
            "
          >
            <span
              className="
                h-[clamp(5px,0.4vw,8px)]
                w-[clamp(5px,0.4vw,8px)]

                shrink-0

                rounded-full

                bg-green-400

                mr-[clamp(0.35rem,0.5vw,0.5rem)]

                animate-pulse
              "
            />

            <span
              className="
                whitespace-nowrap

                text-[clamp(9px,0.8vw,14px)]

                font-medium

                text-blue-100
              "
            >
              Workforce Management Platform
            </span>
          </div>

          {/* ==================================================
              WORKVISTA HEADING
          ================================================== */}

          <h1
            className="
              mb-[clamp(0.5rem,0.9vw,1rem)]

              text-[clamp(2.25rem,4vw,3.75rem)]

              font-extrabold

              leading-none

              tracking-tight
            "
          >
            <span
              className="
                bg-gradient-to-r
                from-white
                via-blue-100
                to-cyan-300

                bg-clip-text

                text-transparent
              "
            >
              WorkVista
            </span>
          </h1>

          {/* ==================================================
              DIVIDER
          ================================================== */}

          <div
            className="
              mx-auto

              mb-[clamp(0.9rem,1.5vw,1.5rem)]

              h-[clamp(2px,0.2vw,4px)]

              w-[clamp(3.5rem,5vw,6rem)]

              rounded-full

              bg-gradient-to-r
              from-cyan-400
              to-blue-500
            "
          />

          {/* ==================================================
              DESCRIPTION
          ================================================== */}

          <p
            className="
              mx-auto

              max-w-[clamp(300px,36vw,520px)]

              text-[clamp(10px,1vw,18px)]

              leading-[clamp(1.2rem,1.6vw,2rem)]

              text-blue-100
            "
          >
            Empowering teams with
            <span
              className="
                font-semibold
                text-white
              "
            >
              {' '}productivity insights
            </span>
            , intelligent employee analytics, and
            operational excellence to drive business growth.
          </p>

          {/*
          ======================================================
          OPTIONAL STATISTICS
          ======================================================

          <div
            className="
              flex
              justify-center
              gap-8
              mt-8
              text-blue-100
            "
          >
            <div className="text-center">
              <h3 className="text-2xl font-bold text-white">
                10K+
              </h3>

              <p className="text-sm">
                Employees
              </p>
            </div>

            <div className="w-px bg-white/20" />

            <div className="text-center">
              <h3 className="text-2xl font-bold text-white">
                500+
              </h3>

              <p className="text-sm">
                Organizations
              </p>
            </div>

            <div className="w-px bg-white/20" />

            <div className="text-center">
              <h3 className="text-2xl font-bold text-white">
                99.9%
              </h3>

              <p className="text-sm">
                Uptime
              </p>
            </div>
          </div>
          */}
        </div>
      </div>
    </div>
  );
};

export default LoginBanner;